import { IOrganization } from '../types';
import { HydraQueryParams, useHydraQuery } from './useHydraQuery';

export function useGetOrganizationsQuery<D extends IOrganization[]>(params?: HydraQueryParams<D>) {
  const { vars, options, key } = params || {};
  return useHydraQuery<D>(key ?? `getOrganizations`, `/api/organizations`, {
    vars,
    options,
  });
}
